import styled from "styled-components";
import { Button } from "../../components/common/Button";
import { PageTitleDetail } from "../../components/common/PageData";

export const Container = styled.div`
  max-width: 1488px;
  margin: 0 auto;
  padding: 44px 20px 76px;

  @media (min-width: 768px) {
    padding: 64px 48px 96px;
  }
`;

export const ActionButton = styled(Button)`
  font-size: 14px;
  min-height: 34px;
  padding: 8px 18px;
  text-transform: uppercase;
  width: 100%;

  @media (min-width: 480px) {
    width: fit-content;
  }
`;

export const AvailabilityBadge = styled.span<{ $isSoldOut: boolean }>`
  background: ${(props) => (props.$isSoldOut ? "#ffefef" : "#e9f8ed")};
  border: 1px solid ${(props) => (props.$isSoldOut ? "#c40000" : "#217a34")};
  color: ${(props) => (props.$isSoldOut ? "#c40000" : "#217a34")};
  display: inline-flex;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 4px 8px;
  text-transform: uppercase;
`;

export const StateMessage = styled(PageTitleDetail)`
  color: #000;
  margin: 40px 0 0;
  text-transform: uppercase;
`;

export const ErrorMessage = styled(StateMessage)`
  color: #c40000;
`;
